// Vue
import { createApp } from 'vue'
import App from '@/App.vue'
import router from './router';
import { IonicVue } from '@ionic/vue';
import { useRoute } from 'vue-router'; // 画面パラメーター取得用

// Ionic
import { Capacitor } from '@capacitor/core';
import { Device } from '@capacitor/device';

// スプラッシュスクリーン
import { SplashScreen } from '@capacitor/splash-screen';

/* Core CSS required for Ionic components to work properly */
import '@ionic/vue/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/vue/css/normalize.css';
import '@ionic/vue/css/structure.css';
import '@ionic/vue/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/vue/css/padding.css';
import '@ionic/vue/css/float-elements.css';
import '@ionic/vue/css/text-alignment.css';
import '@ionic/vue/css/text-transformation.css';
import '@ionic/vue/css/flex-utils.css';
import '@ionic/vue/css/display.css';

/* Theme variables */
import './theme/variables.css';

// Google Maps
import { Loader } from 'google-maps';

// SQLite用
import { CapacitorSQLite, SQLiteConnection } from "@capacitor-community/sqlite"

// 設定ファイル読み込み
import * as Conf from './conf';

// メモった！、キニッタ！共通
import * as GVar from '@/components/00/Var00';  // 共通変数
import * as Tools from '@/components/00/Tools'; // 共通ツール
import * as GFunc from '@/components/00/Common00';  // 共通メソッド
import * as DB from '@/components/00/db/DbInit';  // DB初期化用メソッド

// メモった！、キニッタ！共通css
import '@/assets/00/css/common.css'; 

// キニッタ！専用
import * as LFunc from '@/components/05/Common05001'; // キニッタ！専用メソッド
import * as DLink from '@/components/05/DynamicLink05001'; // ダイナミックリンク

// キニッタ！専用css
import '@/assets/05/css/help.css'; 
import '@/assets/05/css/p05001.css';

// QRコード用
import VueQrcode from '@chenfengyuan/vue-qrcode';

// FloatingVue(tooltip用)
import FloatingVue from "floating-vue";
import 'floating-vue/dist/style.css'

// アプリ生成
const app = createApp(App)
  .use(IonicVue)
  .use(router)
  .use(FloatingVue)
  ;

// QRコード用準備
app.component(VueQrcode.name!, VueQrcode);
  
router.isReady().then(() => {
  app.mount('#app');

});

// 初期処理呼び出し
init();

/**
 * 初期定理
 */
async function  init()
{
  // デバッグフラグ設定 true/false
  GVar.setDebugEnabled(Conf.debugFlag[Conf.env]);
  if ( GFunc.isDebugEnabled() ) {console.log("main init()");}  

  // デバイスID取得は同期が必要
  const did = await Device.getId();
  GVar.setDeviceId(did.uuid);

  //
  // 共通環境設定
  //
  GVar.setEnv(Conf.env);
  // サーブレットURLをセット
  GVar.setServerUrl(Conf.serverUrl[GVar.env]);
  GVar.setServerUrl2(Conf.serverUrl2[GVar.env]); 

  //
  // キニッタ！専用
  //    

  // システムコード設定
  GVar.setSysCd("05");
  // テンプレートコード設定
  GVar.setTmpltCd("001");
  // プロダクト名設定
  GVar.setProductName(LFunc.getProperty("product.name.05.001")!);
  // ログインページ
  GVar.setLoginPage("S05001000");
  // トップページ設定
  GVar.setTopPage("S05001001");

  // 共通画面ラベルの設定
  GVar.setLblTitle(GFunc.getProperty('sproduct.name.05.001')!);
  GVar.setLblFooter(GFunc.getProperty('product.name.05.001')!);
  GVar.setLblLogout(GFunc.getProperty('screen.common.label.logout')!);
  GVar.setLblNm(GFunc.getProperty('screen.P109009.label.name')+":");

  // 日付設定
  GVar.setToday(new Date());

  // Google Mapロード
  GVar.setMapLoader(new Loader(GVar.apiKeys[Capacitor.getPlatform()]));

  //
  // 端末別初期設定
  //
  if(Tools.isIOS())
  {
    // --------------------------
    // iOS用処理
    // --------------------------

    // スプラッシュスクリーンを表示（Androidの場合はこの関数を呼ばなくても表示されるため不要）
    await SplashScreen.show({
      showDuration: 2000, // この設定は効いてない
      autoHide: false
    });
  }

  if(Tools.isIOS() || Tools.isAndroid())
  {
    // --------------------------
    // Android, iOS共通処理
    // --------------------------

    // SQLite初期化
    const sqlite: SQLiteConnection = new SQLiteConnection(CapacitorSQLite);
    GVar.setSqlite(sqlite);
    
    // DB初期化
    await DB.initializeDatabase();

    // Android固有
    if(Tools.isAndroid() )
    {
      GVar.setTtype(GFunc.getProperty("TERMINAL.OS.NAME.ANDROID")!);
    }
    // iOS固有
    else if(Tools.isIOS())
    {
      GVar.setTtype(GFunc.getProperty("TERMINAL.OS.NAME.IOS")!);
    }
    // 通常起動の時はディスパッチを呼び出し、トップページに遷移する
    if ( GVar.runMode == "1" ) {await LFunc.dispatch();}
  }
  else
  {
    // --------------------------
    // PC用処理
    // --------------------------
    GVar.setTtype(GFunc.getProperty("TERMINAL.OS.NAME.OTHERS")!);
    // PCの場合はオートログインがないので必ず検索ページに遷移する
    await LFunc.noLogin();
  }
  // ダイナミックリンク用リスナー設定
  DLink.addDynamicLinkListener();
  // ダイナミックリンクディスパッチャーを設定
  GVar.setDynamiclinkDispatcherFunc(DLink.dynamicLinkDispatcher);
}